export function resolveConvexSiteUrl(
  explicitSiteUrl: string | undefined,
  convexCloudUrl: string | undefined
): string {
  const explicit = explicitSiteUrl?.trim();
  const cloud = convexCloudUrl?.trim();

  if (explicit) {
    try {
      const explicitUrl = new URL(explicit);
      const cloudUrl = cloud ? new URL(cloud) : undefined;
      const explicitDeployment = explicitUrl.hostname.endsWith('.convex.site')
        ? explicitUrl.hostname.slice(0, -'.convex.site'.length)
        : undefined;
      const cloudDeployment = cloudUrl?.hostname.endsWith('.convex.cloud')
        ? cloudUrl.hostname.slice(0, -'.convex.cloud'.length)
        : undefined;

      if (
        !explicitDeployment ||
        !cloudDeployment ||
        explicitDeployment === cloudDeployment
      ) {
        return explicitUrl.origin;
      }
    } catch {
      return explicit.replace(/\/$/, '');
    }
  }

  if (!cloud) return '';

  try {
    const url = new URL(cloud);
    if (url.hostname.endsWith('.convex.cloud')) {
      url.hostname = `${url.hostname.slice(0, -'.convex.cloud'.length)}.convex.site`;
    }
    url.pathname = url.pathname.replace(/\/$/, '');
    url.search = '';
    url.hash = '';
    return url.toString().replace(/\/$/, '');
  } catch {
    return cloud.replace(/\/$/, '');
  }
}

export function requireConvexSiteUrl(
  explicitSiteUrl: string | undefined,
  convexCloudUrl: string | undefined
): string {
  const siteUrl = resolveConvexSiteUrl(explicitSiteUrl, convexCloudUrl);
  if (!siteUrl) {
    throw new Error(
      'Convex site URL is missing. Configure CONVEX_SITE_URL, NEXT_PUBLIC_CONVEX_SITE_URL, or NEXT_PUBLIC_CONVEX_URL.'
    );
  }
  return siteUrl;
}
